<template>
    <div class="matchRequestsTable">
        <div class="filterContainer">
            <div class="filter">
                <div class="name">{{__("matchrequests.filter_average")}}</div>
                <div class="value">
                    <select @change="setFilter()" v-model="filterAverage">
                        <option value="0">0-180</option>
                        <option value="1">1-40</option>
                        <option value="40">40-60</option>
                        <option value="60">60-75</option>
                        <option value="75">75-90</option>
                        <option value="90">90+</option>
                    </select>
                </div>
            </div>

            <div class="filter">
                <div class="name">{{__("matchrequests.filter_boardtype")}}</div>
                <div class="value">
                    <select v-model="filterBoard" @change="setFilter()">
                        <option value="0">{{__("matchrequests.filter_all_types")}}</option>
                        <option value="1" v-if="boardtype == 1">{{__("matchrequests.filter_like_profile", {"profiletype" : "Steel Dart"})}}</option>
                        <option value="2" v-if="boardtype == 2">{{__("matchrequests.filter_like_profile", {"profiletype" : "E-Dart"})}}</option>
                        <option value="2">{{__("matchrequests.filter_only")}} E-Dart</option>
                        <option value="1">{{__("matchrequests.filter_only")}} Steel Dart</option>
                    </select>
                </div>
            </div>

            <div class="filter">
                <div class="name">{{__("matchrequests.filter_audio_video")}}</div>
                <div class="value d-flex flexfull">
                    <div class="filter-entry">
                        <input type="checkbox" name="filter_camera1" id="filter_camera1" v-model="filterCamera1" @change="setFilter()">
                        <label for="filter_camera1"><svg style="width:20px;height:20px;margin-top: -4px" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12,2A7,7 0 0,1 19,9A7,7 0 0,1 12,16A7,7 0 0,1 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9A5,5 0 0,0 12,14A5,5 0 0,0 17,9A5,5 0 0,0 12,4M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M6,22A2,2 0 0,1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20A2,2 0 0,1 18,22H6Z" />
                            </svg> {{__("matchrequests.boardcam")}}
                        </label>
                    </div>
                    <div class="filter-entry">
                        <input type="checkbox" name="filter_camera2" id="filter_camera2" v-model="filterCamera2" @change="setFilter()">
                        <label for="filter_camera2"><svg style="width:20px;height:20px;margin-top: -4px" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12,2A7,7 0 0,1 19,9A7,7 0 0,1 12,16A7,7 0 0,1 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9A5,5 0 0,0 12,14A5,5 0 0,0 17,9A5,5 0 0,0 12,4M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M6,22A2,2 0 0,1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20A2,2 0 0,1 18,22H6Z" />
                            </svg> {{__("matchrequests.playercam")}}
                        </label>
                    </div>
                    <div class="filter-entry">
                        <input type="checkbox" name="filter_microphone" id="filter_microphone" v-model="filterMicrophone" @change="setFilter()">
                        <label for="filter_microphone"><i class="fas fa-microphone"></i> {{__("matchrequests.filter_audiochat")}}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="matchrequest-entries" v-if="Lobby != null">
            <div class="matchrequest-entry entry-header">
                <div class="date">{{__("matchrequests.date")}}</div>
                <div class="matchtype">{{__("matchrequests.match_type")}}</div>
                <div class="setslegs">{{__("matchrequests.sets")}} & {{__("matchrequests.legs")}}</div>
                <div class="options">{{__("matchrequests.gameoptions")}}</div>
                <div class="lobby"></div>
                <div class="players">{{__("matchrequests.players")}}</div>
                <div class="actions"></div>
            </div>
            <div class="matchrequest-entry" v-for="request in Lobby.activeRequests" v-bind:key="request.id" :class="[request.challenge ? 'challenge' : '']">
                <div class="date">
                    <span v-if="request.scheduled_date">{{moment(request.scheduled_date).fromNow()}} <br> {{moment(request.scheduled_date).format("DD.MM. HH:mm")}}</span>
                    <span v-else>{{moment(request.created_at).fromNow()}}</span>
                </div>
                <div class="matchtype">
                    <div class="badge-half steel-edart" v-if="request.boardtype == 0">
                        <i class="icn-kombiboard" title="Alle Boards"></i>
                        <span>{{request.matchtype.name}}</span>
                    </div>
                    <div class="badge-half steel" v-if="request.boardtype == 1">
                        <i class="icn-steelboard" title="Steel-Dart"></i>
                        <span>{{request.matchtype.name}}</span>
                    </div>
                    <div class="badge-half edart" v-if="request.boardtype == 2">
                        <i class="icn-eboard" title="E-Dart"></i>
                        <span>{{request.matchtype.name}}</span>
                    </div>

                    <div class="requirements">
                        <span class="badge rounded-pill bg-danger text-light p-2 m-1" v-if="request.ranked"><i class="fas fa-medal" title="Ranglistenspiel"></i></span>
                        <span v-if="request.cameras > 0" class="webcam">
                            <svg style="width:20px;height:20px;margin-top: -4px" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M12,2A7,7 0 0,1 19,9A7,7 0 0,1 12,16A7,7 0 0,1 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9A5,5 0 0,0 12,14A5,5 0 0,0 17,9A5,5 0 0,0 12,4M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M6,22A2,2 0 0,1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20A2,2 0 0,1 18,22H6Z" />
                            </svg>
                            <div class="webcamnumber" v-html="request.cameras"></div>
                        </span>
                        <span class="microphone" v-if="request.microphone == 1">
                            <i class="fas fa-microphone"></i>
                        </span>
                    </div>
                </div>
                <div class="setslegs">
                    <span class="">{{__("matchrequests.sets")}}: {{request.sets}}</span><span>{{__("matchrequests.legs")}}: {{request.legs}}</span>
                </div>
                <div class="options">
                    <span class="badge rounded-pill bg-secondary text-light p-2 m-1" v-for="item in request.options" v-bind:key="item.name">{{__(item.name)}}: {{__(item.value)}}</span>
                    <br>
                    <span class="badge rounded-pill bg-warning p-1">{{__("matchrequests.firstleg")}}: {{getOption(request.starting_options, "starting_firstleg")}}</span>
                    <span class="badge rounded-pill bg-warning p-1">{{__("matchrequests.otherlegs")}}: {{getOption(request.starting_options, "starting_otherlegs")}}</span>
                </div>
                <div class="lobby">
                    {{__("matchrequests.inlobby")}}: <span>{{request.closedslots}} / {{parseInt(request.openslots + request.closedslots)}}</span>
                </div>
                <div class="players">
                    <div v-if="request.user.id == user_id && request.user2">
                        {{__("matchrequests.challenge_to")}}: <br><player-card :player="request.user2.player" :user="request.user2"/>
                    </div>
                    <div v-if="request.user2 && request.user2.id == user_id ">
                        {{__("matchrequests.challenged_by")}}: <br><player-card :player="request.user.player" :user="request.user"/>
                    </div>
                    <div v-if="!request.user2">
                        <div><player-card :player="request.user.player" :user="request.user"/></div>
                        <!-- <div class="badge rounded-pill bg-warning p-1">Avg: 34,6</div> -->
                    </div>

                    <div v-if="request.external_league">
                        {{__("matchrequests.league")}}: {{request.external_league.name}}
                    </div>
                </div>
                <div class="actions">
                    <a :href="'/matchrequests/' + request.id" v-if="testOpenGameState(request) == 'join'" class="btn btn-success">{{__("matchrequests.join")}}</a>
                    <a :href="'/matchrequests/' + request.id" v-if="testOpenGameState(request) == 'own'" class="btn btn-block btn-success">{{__("matchrequests.details")}}</a>
                    <a href="#" v-if="testOpenGameState(request) == 'absent'" class="btn btn-block btn-secondary disabled">{{__("matchrequests.absent")}}</a>
                    <a href="#" v-if="testOpenGameState(request) == 'denied'" class="btn btn-block btn-secondary disabled" v-html="__('matchrequests.denied')"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PlayerCard from './PlayerCard.vue';
import ToastErrorVue from './ToastError.vue';
    export default {
        props: {
            user_id: {
                type: Number,
            },
            dashboard: {
                type: Boolean
            }
        },
        data() {
            return {
                requests: [],
                activeRequests: [],
                users: [],
                modal: {},
                current_match_request_id: null,
                Lobby: null,
                boardtype: 0,
                boardfilter: 0,

                filterBoard: 0,
                filterCamera1: false,
                filterCamera2: false,
                filterAverage: 0,
                filterMicrophone: false,

            }
        },
        mounted() {
            this.Lobby = window.Lobby;
            this.boardtype = window.currentProfile ? window.currentProfile.boardtype : 0;

            Echo.channel('matchrequests')
                .listen('.request.canceled', (e) => {
                    if (e.match_request_id == this.current_match_request_id) {
                        this.requestCanceled();
                    }
                })
                 .listen('.request.start', (e) => {
                    if (e.match_request_id == this.current_match_request_id) {
                        this.matchStarted(e.match_id);
                    }
                })
        },
        methods: {
            join(id) {
                var data = {
                    user_id: this.user_id,
                    request_id: id
                }
                this.current_match_request_id = id;
                axios.post('/api/matchrequests/join', data);
                this.$bvModal.show('modal-matchrequests-clicked');
            },
            abort(id) {
                axios.delete('/api/matchrequests/abort/' + id).then(() => {
                    toastError('Anfrage geloescht');
                    this.Lobby.reloadRequests();
                })
            },
            cancelRequest() {
                axios.post('/api/matchrequests/cancel', {'id':this.current_match_request_id});
                this.$bvModal.hide('modal-matchrequests');
            },
            requestCanceled() {
                this.current_match_request_id = null
                this.$bvModal.hide('modal-matchrequests-clicked');
                this.$bvModal.hide('modal-matchrequests');
                toastError('Request canceled');
            },
            startMatch() {
                axios.post('/api/matchrequests/start', {'id':this.current_match_request_id, 'user2': this.modal.user2.id});
            },
            matchStarted(match_id) {
                toastSuccess('Starting match...');
                //redirect to the match page
                window.location.href = "/games/" + match_id;
            },
            getOption(arr, id) {
                var option = "";
                arr.forEach(element => {
                    if (element.name == id) option = element.value;
                });
                return option;
            },
            switchBoardfilter(evt) {
                var filter = parseInt(evt.target.value);
                this.Lobby.setBoardfilter(filter);
            },
            setFilter() {
                this.Lobby.setFilter(
                    [{name:"average", value: this.filterAverage},
                    {name:"boardtype", value: this.filterBoard},
                    {name:"camera1", value: this.filterCamera1},
                    {name:"camera2", value: this.filterCamera2},
                    {name:"microphone", value: this.filterMicrophone}]
                );
                this.Lobby.updateRequests();
            },
            testOpenGameState(request) {
                if (this.dashboard) {
                    if (request.user.id != this.user_id && request.activeUser) return "join"
                } else {
                    if (request.user.id == this.user_id) return "own";
                    else {
                        if (window.currentProfile.boardtype != request.boardtype && request.boardtype != 0) return "denied";
                        if (!request.activeUser) return "absent";
                        if (request.openslots > 0) return "join";
                    }
                }
                return "join";
            }
        }
    }
</script>
